import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import '../styles/Header.css';
import logoImage from '../assets/images/e-invitation_logo.webp';

const Header = () => {
  const location = useLocation();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const isHomePage = location.pathname === '/';
  
  useEffect(() => {
    const handleScroll = () => {
      const isScrolled = window.scrollY > 10;
      setScrolled(isScrolled);
    };

    if (isHomePage) {
      window.addEventListener('scroll', handleScroll);
      // Check initial scroll position
      handleScroll();
      return () => window.removeEventListener('scroll', handleScroll);
    } else {
      // Reset scrolled state for non-home pages
      setScrolled(false);
    }
  }, [isHomePage]);
  
  useEffect(() => {
    // Prevent body scroll when mobile menu is open
    if (mobileMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [mobileMenuOpen]);
  
  const navItems = [
    { path: '/', label: 'Home' },
    { path: '/invitations', label: 'Designs' },
    { path: '/pricing', label: 'Pricing' },
    { path: '/about', label: 'About' }
  ];

  const headerClass = isHomePage 
    ? `header header-transparent ${scrolled ? 'header-scrolled' : ''}`
    : 'header header-solid';

  return (
    <header className={headerClass}>
      <div className="header-container">
        <Link to="/" className="logo">
          <img src={logoImage} alt="E-Invitation Logo" className="logo-icon" />
          <div className="logo-text">
            <h1>E-Invitation</h1>
          </div>
        </Link>
        
        <button 
          className="mobile-menu-btn"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          aria-label="Toggle menu"
          aria-expanded={mobileMenuOpen}
        >
          <span className={`hamburger-icon ${mobileMenuOpen ? 'open' : ''}`}>
            <span></span>
            <span></span>
            <span></span>
          </span>
        </button>
        
        {/* Mobile Menu Backdrop */}
        <div 
          className={`mobile-menu-backdrop ${mobileMenuOpen ? 'active' : ''}`}
          onClick={() => setMobileMenuOpen(false)}
          aria-hidden="true"
        />
        
        {/* Navigation */}
        <nav className={`nav ${mobileMenuOpen ? 'nav-open' : ''}`}>
          <ul className="nav-list">
            {navItems.map((item) => (
              <li key={item.path} className="nav-item">
                <Link
                  to={item.path}
                  className={`nav-link ${location.pathname === item.path ? 'active' : ''}`}
                  onClick={() => setMobileMenuOpen(false)}
                >
                  {item.label}
                </Link>
              </li>
            ))}
          </ul>
          
          {/* Mobile Menu Actions */}
          <div className="mobile-menu-actions">
            <a 
              href="https://logicatechnology.com" 
              target="_blank" 
              rel="noopener noreferrer"
              className="btn btn-outline"
              onClick={() => setMobileMenuOpen(false)}
            >
              Visit Logica
            </a>
            <Link 
              to="/book" 
              className="btn btn-primary"
              onClick={() => setMobileMenuOpen(false)}
            >
              Book Now
            </Link>
          </div>
        </nav>
        
        <div className="header-actions">
          <a 
            href="https://logicatechnology.com" 
            target="_blank" 
            rel="noopener noreferrer"
            className="btn btn-outline"
          >
            Visit Logica
          </a>
          <Link to="/book" className="btn btn-primary">
            Book Now
          </Link>
        </div>
      </div>
    </header>
  );
};

export default Header;
